module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "dialog-wrapper",
      "title": _vm.dialogTitle,
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "visible": _vm.dialogVisible,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "label-width": "180px",
      "label-position": "left",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "校区范围"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.isAll),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isAll", $$v)
      },
      expression: "formData.isAll"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("全量")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("部分")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.campusSelectLabel
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择校区",
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formData.campusList),
      callback: function($$v) {
        _vm.$set(_vm.formData, "campusList", $$v)
      },
      expression: "formData.campusList"
    }
  }, _vm._l((_vm.campusDataSource), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label + '（' + item.value + '）',
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n               共计" + _vm._s(_vm.formData.campusList.length) + "个校区\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "flex-row-center"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickSave
    }
  }, [_vm._v("确定")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55c7932c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/PhysicalReportCampusShield.vue
// module id = 1031
// module chunks = 0